import React, { memo } from 'react'
import { useFormatPublicationDate } from '@/utils/hooks/format/useFormatPublicationDate'
import type { IPublicationHeaderProps } from './interface'
import './styles.scss'

const PublicationHeader: React.FC<IPublicationHeaderProps> = props => {
  const { publication } = props

  const { title, subtitle, publicationDate, author, type } = publication || {}
  const { formatPublicationDate } = useFormatPublicationDate(type)

  return (
    <header className="publication-header">
      {publicationDate && (
        <p className="text_small publication-header__date">
          {formatPublicationDate(publicationDate)}
          {author && <>, {author}</>}
        </p>
      )}
      <div className="publication-header__title">
        <h1 className="h2 publication-header__h1">{title}</h1>
        {subtitle && <p className="h3-from-sm h5-sm">{subtitle}</p>}
      </div>
    </header>
  )
}

export default memo(PublicationHeader)
